import { FC } from 'react';

import { FormDateField } from '@/components/FormElements/FormDateField/FormDateField';

import { FormAutoCompleteField } from './FormAutoCompleteField';
import {
  FormFileInputField,
  FormFileInputFieldProps,
} from './FormFileInputField';
import { FormInputField, FormInputFieldProps } from './FormInputField';
import { FormSelectField, FormSelectFieldProps } from './FormSelectField';
import {
  FormSwitchField,
  FormSwitchFieldProps,
} from './FormSwitchField/FormSwitchField';

export const RenderFormField: FC<
  FormInputFieldProps &
    FormSelectFieldProps &
    FormSwitchFieldProps &
    FormFileInputFieldProps
> = (props) => {
  const { type } = props;

  if (type === 'select') {
    return <FormSelectField {...props} />;
  }

  if (type === 'autocomplete') {
    return <FormAutoCompleteField {...props} />;
  }

  if (type === 'toggle') {
    return <FormSwitchField {...props} />;
  }

  if (type === 'file') {
    return <FormFileInputField {...props} />;
  }

  if (type === 'date') {
    return <FormDateField {...props} />;
  }
  return <FormInputField {...props} />;
};
